module.exports = __webpack_public_path__ + "static/repair-76aca6e576b58ee54d92b892e146d0e9.png";